angular
	.module 'App.Repository'
.factory 'ReasonCodeRepository', ['BaseRepository', (BaseRepository) ->
	class ReasonCodeRepository extends BaseRepository
		@resource = '/reason_codes'
		@isRestricted = true

		findByQuery: (query = null) ->
			if _.isEmpty(query)
				query = @createQuery()

			if !query.isSorted()
				query.sortBy 'name', 'ASC'

			super query

		list: (showDeleted = false) ->
			query = @createQuery()
			query.addParameter('show_deleted', showDeleted)

			return @findByQuery(query)

	return new ReasonCodeRepository
]
